import React, { FC, useEffect, useState } from "react";

import "swiper/components/navigation/navigation.min.css";
import "swiper/swiper.min.css";
import Linkify from "linkify-react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import SwiperCore, { Autoplay, Navigation } from "swiper/core";
import { Swiper, SwiperSlide } from "swiper/react";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { incidentMessageApi } from "@/shared/apis";

import { StyledIncidentMessage } from "./styled";

type IncidentMessageProps = {
    incidents?: MyBrokerApi.IncidentMessage[];
};

SwiperCore.use([Navigation, Autoplay]);

const IncidentMessage: FC<IncidentMessageProps> = () => {
    const theme = useTheme();
    const { i18n } = useTranslation();
    const [severity, setSeverity] = useState(null);
    const [openIncidentMessage, setOpenIncidentMessage] = useState(true);
    const isMobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const { data: incidents = [] } = useQuery(
        ["incidentMessage", { language: i18n.language }],
        incidentMessageApi.getIncidentMessage,
        {
            suspense: false,
            useErrorBoundary: false,
        },
    );

    const switchIncidentSeverityFor = (index: number) => {
        if (incidents?.[index]) {
            setSeverity(incidents[index].severity.id);
        }
    };

    useEffect(() => {
        switchIncidentSeverityFor(0);
    }, [incidents]);

    const getIcon = (severityId) => {
        switch (severityId) {
            case 1:
                return <InfoOutlinedIcon fontSize="large" />;
            case 2:
                return <ReportProblemOutlinedIcon fontSize="large" />;
            case 3:
                return <ErrorOutlineOutlinedIcon fontSize="large" />;
            default:
                return null;
        }
    };

    if (incidents.length === 0 || !openIncidentMessage) return <></>;

    return (
        <StyledIncidentMessage $severity={severity}>
            <Swiper
                navigation
                slidesPerView={1}
                loop={incidents.length > 1}
                autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                }}
                onSlideChange={(e) => {
                    switchIncidentSeverityFor(e.realIndex);
                }}
            >
                {incidents.map((incident) => (
                    <SwiperSlide key={incident.message}>
                        <div className="message" role="alert">
                            {!isMobileScreen && getIcon(incident.severity.id)}
                            <div>
                                <Linkify options={{ attributes: { target: "_blank" } }}>{incident.message}</Linkify>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
            <CloseIcon fontSize="large" className="pointer" onClick={() => setOpenIncidentMessage(false)} />
        </StyledIncidentMessage>
    );
};

export default IncidentMessage;
